import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { CompaniesFormData } from "../../types";

export const KeyContactEmailAddressField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<CompaniesFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography>Email Address</Typography>
      <TextInput
        className="w-full"
        type="email"
        hasError={!!errors.keyContactEmailAddress}
        placeholder="Enter Email Address"
        maxLength={100}
        {...register("keyContactEmailAddress")}
      />
      <ErrorMessage errors={errors} name="keyContactEmailAddress" />
    </div>
  );
};
